import { OnboardingRepository } from "../repositories/OnboardingRepository";
import { SignupPhotoLivenessCheckResult } from "../entities/signupPhotoLiveness";

export interface CheckSignupPhotoLivenessParams {
	file: File;
	maritalStatusId?: string;
}

export class CheckSignupPhotoLiveness {
	constructor(private repository: OnboardingRepository) {}

	execute(params: CheckSignupPhotoLivenessParams): Promise<SignupPhotoLivenessCheckResult> {
		return this.repository.checkSignupPhotoLiveness(params);
	}
}
